/**
 * Generate a UUID v4 string using the uuid package or crypto API
 * @returns A UUID v4 string
 */
export function generateUUID(): string {
  try {
    // Try using the crypto API with a modern approach
    if (window.crypto && window.crypto.randomUUID) {
      return window.crypto.randomUUID();
    }
    
    // Fallback to the uuid package
    const { v4: uuidv4 } = require('uuid');
    return uuidv4();
  } catch (error) {
    console.error('Error generating UUID:', error);
    
    // Final fallback - generate a simple unique string
    return 'temp-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
  }
} 